$(document).on('turbolinks:load', function() {
    
    if ($('[data-toggle="tooltip"').length > 0) {
        $('body').tooltip({selector: '[data-toggle="tooltip"]'});
    }
    
});